export default (text, caracters = 10) =>
  text.length > caracters ? `${text.substring(0, caracters)}...` : text
